import Vue from 'vue';
import ElementUI from 'element-ui';
import App from './App';
import router from './router';
import store from '../../store/index';

import '../../utils/directive/display';
import { checkLogin } from '../../utils/index';
import '../../../theme/index.css';
import '../../styles/base.less';
import 'babel-polyfill';
// import utils from '@/utils/common';
import '../../utils/btnPermission';
import echarts from 'echarts';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { I18n, $translate } from '@/utils/i18n';
import './styles/logisticsV3.less';
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
// import './mock/mymockjs.js';
/**
 * @description 增加大数据埋点
 */
import bigDataLog from '@/utils/bigDataLog';
import bigDataLogV2 from '@/utils/bigDataLogV2';
// import intimeevaluate from 'intimeevaluate';
import microApp from '@micro-zoe/micro-app';
import { regeisterRoutes } from '@/utils/base';
import addRouters from './modules';
import Home from './views/Home.vue';
/**
 * @description 京东微前端
 */
microApp.start();
/**
 * @description 子应用设置基础路由
 * 设置基础路由，子应用可以通过window.__MICRO_APP_BASE_ROUTE__获取基座下发的baseroute
 * 如果没有设置baseroute属性，则此值默认为空字符串
 */
let oldPath = null;
if (window.__MICRO_APP_BASE_ROUTE__) {
    window.microApp.addDataListener((data) => {
        if (data.path && data.path !== oldPath) {
            oldPath = data.path;
            router.push(data.path);
        }
    });
};

const moduleName = 'C-SNP';
bigDataLog.init(moduleName);
bigDataLogV2.init(moduleName);

Vue.prototype.$echarts = echarts;
(async function () {
Vue.use(Viewer);
Vue.use(VueQuillEditor);
const whiteList = [];

checkLogin(router, whiteList, () => regeisterRoutes(addRouters, router, Home));
Vue.prototype.$driver = new Driver({ // 全局指引实例
    doneBtnText: '完成',
    closeBtnText: '跳过指引',
    nextBtnText: '下一步',
    prevBtnText: '上一步',
    className: 'wrap-driver',
    allowClose: false // 不允许点击遮罩层关闭
});
Vue.mixin({
    methods: {
        // 用于处理语言包不存在的时候 使用缺省值
        $translate(key, params) {
            return $translate(key, params);
        }
    }
});
store.dispatch('UPDATE_LANG').then(() => {
    const i18n = I18n();
    Vue.use(ElementUI, {
        i18n: (path, options) => {
            const value = i18n.t(path, options);
            if (value) return value;
            return '';
        }
    });
    // Vue.use(intimeevaluate);
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app');
});
}());